import React, { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';

export default function CheckoutRedirect() {
  const location = useLocation();
  const hasOpenedRef = useRef(false);

  // Extract everything after "checkout_url=" to keep all & query params intact
  const getFullCheckoutUrl = () => {
    const search = location.search;
    const key = 'checkout_url=';
    const index = search.indexOf(key);

    if (index === -1) return null;

    const rawUrl = search.substring(index + key.length);

    try {
      return decodeURIComponent(rawUrl);
    } catch {
      return rawUrl;
    }
  };

  const checkoutUrl = getFullCheckoutUrl();

 useEffect(() => {
  if (checkoutUrl && !hasOpenedRef.current) {
    hasOpenedRef.current = true;
    window.location.href = checkoutUrl;
  }
}, [checkoutUrl]);

  if (!checkoutUrl) {
    return (
      <div className="p-8 text-center">
        <h2 className="text-xl font-bold">Invalid Checkout Link</h2>
        <p className="text-gray-600">No checkout URL was provided.</p>
      </div>
    );
  }

  return (
    <div className="p-8 text-center">
      <h2 className="text-xl font-bold">Redirecting to Payment...</h2>
      <p className="text-gray-600 mt-2">
        Opening payment gateway in a new tab...
      </p>
    </div>
  );
}